import React from 'react';
import {Paper} from 'material-ui';
import {connect} from 'react-redux';
import classNames from 'classnames';
import SectionActions from './section_actions';
import ReactPlaceholder from 'react-placeholder';
import {sectionProjectsPlaceholder} from './section_placeholder';
import SectionTitle from './section_title';
import {changeSectionBgColor} from '../../actions';

/*
 * Many sections look identical and BaseSection captures
 * the look and feel of the canonical section. Any section
 * that does not require any particular rendering enhancement
 * may extend this base section.
 *
 * TODO: refactor all existing sections that are copies of
 * this section to instead inherit from it.
 **/
class BaseSection extends React.Component {
    render() {
        const {
            isDragging,
            connectDragSource,
            connectDragPreview,
            connectDropTarget,
            classes,
            changeSectionBgColor,
            sectionBgColorId,
            isVisible,
        } = this.props;

        const opacity = isDragging ? 0 : 1;

        let sectionPaperClassNames = classNames(
            classes.pbSection,
            classes.root,
            this.props.new && this.props.touched && classes.new,
            this.props.touched && !this.props.new && classes.touched,
            !isVisible && classes.pbSectionReadonly
        );

        return connectDragPreview(
            connectDropTarget(
                <div>
                    <Paper
                        style={{opacity}}
                        className={sectionPaperClassNames}
                        elevation={2}
                    >
                        <SectionTitle
                            classes={classes}
                            sectionType={this.props.sectionType}
                            title={this.props.title}
                            connectDragSource={connectDragSource}
                            hideDragIcon={this.props.hideDragIcon}
                            changeSectionBgColor={(sectionBgColorId) =>
                                changeSectionBgColor(
                                    sectionBgColorId,
                                    this.props.id,
                                    this.props.pageId
                                )
                            }
                            sectionBgColorId={sectionBgColorId}
                        />

                        <ReactPlaceholder
                            rows={5}
                            ready={false}
                            customPlaceholder={sectionProjectsPlaceholder}
                        >
                            {''}
                        </ReactPlaceholder>

                        <SectionActions
                            classes={this.props.classes}
                            deleteSection={(ev) =>
                                this.props.deleteSection(ev, this.props.id)
                            }
                        />
                    </Paper>
                </div>
            )
        );
    }
}

export default connect(
    () => {
        return {};
    },
    {
        changeSectionBgColor,
    }
)(BaseSection);



// WEBPACK FOOTER //
// ./src/containers/builder/sections/tab_dnd/section_base.js